import { pOturumAc, rKullanici, rValue } from '../../../../api/models/.catalog';
import { ActionSubTypes } from '../../../ActionSubTypes';
import Api from '../../../../api/ApiWrapper';
import { IApiAction, IInputAction, IPromiseAction } from '../../../../models/ActionModels';
import ActionFunctions from '../../../core/ActionFunctions';
import { IError } from '../../../../models/StateModels';
import pOtpKontrol from '../../../../api/models/pOtpKontrol';
import rOtp from '../../../../api/models/rOtp';

export const action_api_set_input = (
  body: pOtpKontrol | null | undefined
): IInputAction<pOtpKontrol> =>
  ActionFunctions.action_api_set_input(ActionSubTypes.API_OTPKONTROL, true, body);

export const action_async_start = (body: pOtpKontrol): IPromiseAction<pOtpKontrol> =>
  ActionFunctions.action_async_start_promise(
    ActionSubTypes.API_OTPKONTROL,
    new Api.User.OtpKontrol().Request(body),
    false,
    false,
    body
  );

export const action_async_complete = (
  data: rValue<rOtp> | null | undefined,
  error: IError | null | undefined
): IApiAction<rOtp> =>
  ActionFunctions.action_async_complete_api<rOtp>(
    ActionSubTypes.API_OTPKONTROL,
    data?.Value,
    error
  );
